import React, { FunctionComponent } from 'react';
import { HotPriceIcon, StyledCurrencyFormat, Wrapper } from './PackageHotPrice.style';

type Props = {
  value?: number;
  className?: string;
};

export const PackageHotPrice: FunctionComponent<Props> = ({ value, className }) => {
  if (!value) {
    return null;
  }
  return (
    <Wrapper className={className}>
      <HotPriceIcon />
      <StyledCurrencyFormat value={value} />
    </Wrapper>
  );
};
